import { AfterViewInit, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { images } from '../../../images';

@Component({
  selector: 'app-custom-toggle',
  templateUrl: './custom-toggle.component.html',
  styleUrls: ['./custom-toggle.component.scss'],
  standalone: false
})
export class CustomToggleComponent implements OnChanges, AfterViewInit {
  @Input() id: string;
  @Input() selectedValue: any;
  @Input() firstValue: any;
  @Input() secondValue: any;
  @Input() firstImage: string;
  @Input() secondImage: string;
  @Input() firstDescription: string = '';
  @Input() secondDescription: string = '';
  @Input() small: boolean = false;
  @Input() color: string = 'primary';
  @Input() firstImageFilter?: string;
  @Input() secondImageFilter?: string;
  @Input() controlled: boolean = false;
  @Output() action: EventEmitter<any> = new EventEmitter();
  
  public secondOption = false;
  public showIcons = true;
  public images = images;
  
  constructor() {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedValue'] && changes['selectedValue'].previousValue && changes['selectedValue'].currentValue) {
      this.ngAfterViewInit();
    }
  }

  ngAfterViewInit(): void {
    this.secondOption = this.selectedValue === this.secondValue;
    document.getElementById(`${this.id}-tumbler`)!.style.transform = `translateX(${this.secondOption ? '85%' : 'calc(0% - 2px)'})`;
  }

  changeMode() {
    if (this.controlled) {
      this.action.emit(this.selectedValue === this.secondValue ? this.firstValue : this.secondValue);
      return;
    }
    this.showIcons = false;
    this.secondOption = !this.secondOption;
    document.getElementById(`${this.id}-tumbler`)!.style.transform = `translateX(${this.secondOption ? '85%' : 'calc(0% - 2px)'})`;

    setTimeout(() => {
      this.showIcons = true;
    }, 300);
    this.action.emit();
  };
}
